module.exports = _.merge;


//////////////////
// WEBPACK FOOTER
// external "_.merge"
// module id = 615
// module chunks = 0